import * as React from 'react'
import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import { BootstrapDialog, BootstrapDialogTitle } from 'common/AbstractModal/BootstrapDialog'

import { NewCampaignPromoForm } from './CampaignPromoForm'

export default function AddCampaignPromoDialog() {
  const [open, setOpen] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  //handle form submit api here
  return (
    <div>
      <Button variant='contained' onClick={handleClickOpen}>
        Add Campaign Promo
      </Button>

      <BootstrapDialog
        fullWidth
        maxWidth='lg'
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={open}
      >
        <BootstrapDialogTitle onClose={handleClose}>
          Add a new campaign promo code
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <NewCampaignPromoForm handleClose={handleClose} />
        </DialogContent>
      </BootstrapDialog>
    </div>
  )
}
